// TarjaDesconto.js — a tarja verde "27% OFF", colada no canto superior esquerdo
// de um card de pacote, inclinada.
//
// Mora aqui, e não dentro de cada tela, porque dois lugares vendem os mesmos
// pacotes — a loja de créditos do perfil e a página do Clube — e o dono pediu
// a mesma tarja nos dois (11/09/2026). Duas cópias divergiriam no primeiro
// ajuste de tamanho, e o mesmo pacote apareceria com duas tarjas diferentes.
//
// O card precisa ser `relative`: a tarja é `absolute` e se projeta 12px acima
// da borda dele, como uma etiqueta colada por cima.
import React from "react";

// ================= A INCLINAÇÃO =================
//
// Mesma ideia das fitas do FAQ (ver ANGULOS_ESQ em faq/Faq.js): colado à mão,
// nada sai duas vezes no mesmo ângulo. A lista é FIXA, e não `Math.random()`,
// porque um sorteio a cada renderização faria a tarja trocar de inclinação
// sozinha ao passar o mouse num botão — e porque fixa ela é igual para todo
// mundo que abre a tela.
//
// Ângulos menores que os das fitas (lá vão até 19°): a fita é enfeite, a tarja
// tem texto, e "27% OFF" inclinado demais deixa de ser lido de relance.
export const ANGULOS_TARJA = [-7, 5, -4, 8, -6, 3, -9, 6];

/** O ângulo da posição `i`, dando a volta na lista. */
export const anguloDaTarja = (i) =>
  ANGULOS_TARJA[((i % ANGULOS_TARJA.length) + ANGULOS_TARJA.length) % ANGULOS_TARJA.length];

const TarjaDesconto = ({ pct, indice = 0 }) =>
  pct > 0 ? (
    <span
      className="absolute -top-3 left-2.5 z-10 whitespace-nowrap rounded-selo bg-insigne-promo px-2.5 py-1
                 text-[13px] font-extrabold uppercase leading-none tracking-wide text-ink-fixed
                 shadow-[2px_2px_0_0_rgb(var(--c-sombra))]"
      style={{ transform: `rotate(${anguloDaTarja(indice)}deg)` }}
    >
      {pct}% OFF
    </span>
  ) : null;

export default TarjaDesconto;
